export class SystemNotification {
    message: string; 
    date: number;
    server: boolean;
    additionalData: any;

    constructor(
        message: string,
        date?: number | null,
        server?: boolean,
        additionalData?: any
    ) {
        this.message = message;
        this.date = date ?? Date.now();
        this.server = server ?? false;
        this.additionalData = additionalData ?? null;
    }

    // This is only intended to be used for the ones loaded from the server
    static BuildSystemNotification(entity: Array<any>): Array<SystemNotification> {
        return entity.map(item => SystemNotification.CreateInstance(item));
    }

    // This is only intended to be used for the ones loaded from the server
    private static CreateInstance(notification: any): SystemNotification {
        return new SystemNotification(notification.NOTIFICATION_TEXT, null, true);
    }
    
    public hasAction(): boolean {
        return this.additionalData?.action !== null;
    }
    
    public getAction(): NotificationAction {
        return this.additionalData?.action;
    }

}

// The known list of action types 
export const enum NotificationAction {
    ShowNotificationList = 'ShowNotificationList',
}
